import { removeSlash } from './removeIdSlash'
const uuid = require('uuid/v1')
const moment = require('moment')

export function ThingsBoardTenantListParser (list) {
  const resultList = list.data.data.map(listItem => {
    const resultItem = {}
    for (const item in listItem) {
      // if (item !== 'id') {
      resultItem[item] = listItem[item]
      // }
    }
    // resultItem.id = listItem.id.id
    // resultItem.name = listItem.name
    // resultItem.title = listItem.title
    return resultItem
  })
  return resultList
}

export function ThingsBoardDeviceListParser (list) {
  const resultList = list.data.data.map(listItem => {
    const resultItem = {}
    for (const item in listItem) {
      resultItem[item] = listItem[item]
      // }
    }
    const additionalInfo = JSON.parse(resultItem.additionalInfo || '{}')
    resultItem.color = additionalInfo.isVirtualDevice ? '#66ccff' : undefined
    resultItem.label = listItem.name
    resultItem.allowDelete = true
    resultItem.allowMod = true
    resultItem.allowCopy = true
    resultItem.children = []
    resultItem.children[0] = {}
    resultItem.children[0].label = '开关量'
    resultItem.children[0].children = []
    resultItem.children[1] = {}
    resultItem.children[1].label = '变量'
    resultItem.children[1]['data-key'] = 'variables'
    resultItem.children[1]['data-device-id'] = listItem.id
    resultItem.children[1].allowAdd = true
    resultItem.children[1].children = []
    resultItem.children[2] = {}
    resultItem.children[2].label = '控制量'
    resultItem.children[2].children = []
    // resultItem.id = listItem.id.id
    // resultItem.name = listItem.name
    // resultItem.additionalInfo = {}
    // resultItem.additionalInfo.type = listItem.type
    return resultItem
  })
  return resultList
}

export function ThingsBoardTenantManagerListParser (list) {
  const resultList = list.data.data.map(listItem => {
    const resultItem = {}
    // const rules = [
    //   'id',
    //   'createdTime',
    //   'authority'
    // ]
    for (const item in listItem) {
      resultItem[item] = listItem[item]
    }
    // resultItem.id = listItem.id.id
    // resultItem.name = listItem.name
    // resultItem.email = listItem.email
    return resultItem
  })
  return resultList
}

export function ThingsBoardTenantUserListParser (list) {
  const resultList = list.data.data.map(listItem => {
    const resultItem = {}
    // const rules = [
    //   'id',
    //   'createdTime',
    //   'authority'
    // ]
    for (const item in listItem) {
      if (item === 'additionalInfo') {
        const append = JSON.parse(listItem[item])
        resultItem[item] = append
        for (const val in append) {
          resultItem[val] = append[val]
          if (val === 'alarmFromEmail') {
            append[val] ? resultItem[val] = '是' : resultItem[val] = '否'
          }
          if (val === 'alarmFromSms') {
            append[val] ? resultItem[val] = '是' : resultItem[val] = '否'
          }
        }
      } else {
        resultItem[item] = listItem[item]
      }
    }
    // resultItem.id = listItem.id.id
    // resultItem.name = listItem.name
    // resultItem.email = listItem.email
    return resultItem
  })
  return resultList
}

// 虚拟表解析
export function ThingsBoardVirtualTableParser (list) {
  const resultList = list.data.map(listItem => {
    const resultItem = {}
    // const rules = [
    //   'id',
    //   'createdTime',
    //   'authority'
    // ]
    for (const item in listItem) {
      // if (!rules.includes(item)) {
      resultItem[item] = listItem[item]
      resultItem.typeInZh = listItem.type === 'inputValue' ? '输入值' : '计算值'
      if (listItem.virtualGroup) {
        resultItem.group = listItem.virtualGroup
        if (!resultItem.group) {
          resultItem.group = ''
        }
        resultItem.virtualGroup = listItem.virtualGroup.split(',')
        if (!resultItem.virtualGroup) {
          resultItem.virtualGroup = []
        }
      }
      // }
    }
    // resultItem.id = listItem.id.id
    // resultItem.name = listItem.name
    // resultItem.email = listItem.email
    return resultItem
  })
  resultList.reverse()
  return resultList
}

export function timeSharingParser (val) {
  let timeSharing = []
  for (const item of val.data) {
    if (item.key === 'timeSharing') {
      timeSharing = JSON.parse(item.value) || []
      timeSharing = timeSharing.filter(v => v.name)
      // let resultTree = []
      for (const item of timeSharing) {
        item.label = item.name
        item.children = item.data
        item.allowDelete = true
        item.id = uuid()
        item.allowAdd = true
        for (const timeList of item.children) {
          timeList.timeSharingType = item.type
          timeList.label = timeList.key
          timeList.allowDelete = true
          timeList.id = uuid()

          if (item.type === 'time') {
            const tempTimeValue = []
            for (const timeItem of timeList.value) {
              const tempTimeItem = []
              tempTimeItem[0] = timeItem.substring(0, 5)
              tempTimeItem[1] = timeItem.substring(6, 11)
              tempTimeValue.push(tempTimeItem)
            }
            timeList.value = tempTimeValue
          }
        }
      }
      return timeSharing || []
    }
  }
}

export function gatewayParser (list) {
  const origData = list.data
  const result = origData.map(gateway => {
    gateway.label = gateway.name
    gateway.loading = false
    gateway.children = []
    gateway.allowAdd = true
    gateway.allowDelete = true
    gateway.shortId = removeSlash(gateway.id.id)
    gateway.isLeaf = false
    gateway.lazy = true
    gateway.createdTimeParsed = moment(gateway.createdTime).format('YYYY-MM-DD HH:mm')
    return gateway
  })
  return result
}

export function devicePropsRegister (reg) {
  const preProcessData = (reg[0] || { value: '' }).value
  // const result = []
  return JSON.parse(preProcessData)
}
